import { MDBCheckbox } from "mdb-react-ui-kit";
import React, { useEffect, useImperativeHandle, useRef, useState, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import ScheduleWeekDay from "../../../components/CallFlows12/weekday";

const DAY_NAME_TO_KEY = {
  Sunday: "sun", Monday: "mon", Tuesday: "tue",
  Wednesday: "wed", Thursday: "thu", Friday: "fri", Saturday: "sat"
};
const NUM_TO_DAY_KEY = { 1: "sun", 2: "mon", 3: "tue", 4: "wed", 5: "thu", 6: "fri", 7: "sat" };
const normDay = (d) => (typeof d === "number" || !isNaN(+d)) && NUM_TO_DAY_KEY[+d] ? NUM_TO_DAY_KEY[+d] : d;
function convertToMinutes(time) {
  const [timePart, modifier] = time.split(" ");
  const [hours, minutes] = timePart.split(":").map(Number);
  let newHours = hours;
  if (modifier === "AM" && newHours === 12) newHours = 0;
  else if (modifier === "PM" && newHours !== 12) newHours += 12;
  return newHours * 60 + minutes;
}

const AddOverride = forwardRef((props, ref) => {
  const tfocus = useRef();
  const { t } = useTranslation();
  const [name, setName] = useState(null);
  const [error, setError] = useState(null);
  const [errorflg , setErrorflg] = useState(null)
  const [dayInternalErrors, setDayInternalErrors] = useState({});
  const [currentOver, setcurrentOver] = useState();
  const [activeBulk, setActiveBulk] = useState(null);

  const [schduleObj, setSchduleObj] = useState({
    schedule: {
      weekly_schedule: {
        sun: { from_time: "08:00 AM", to_time: "05:00 PM", selected: false, twenty_four: false },
        mon: { from_time: "08:00 AM", to_time: "05:00 PM", selected: true, twenty_four: false },
        tue: { from_time: "08:00 AM", to_time: "05:00 PM", selected: true, twenty_four: false },
        wed: { from_time: "08:00 AM", to_time: "05:00 PM", selected: true, twenty_four: false },
        thu: { from_time: "08:00 AM", to_time: "05:00 PM", selected: true, twenty_four: false },
        fri: { from_time: "08:00 AM", to_time: "05:00 PM", selected: true, twenty_four: false },
        sat: { from_time: "08:00 AM", to_time: "05:00 PM", selected: false, twenty_four: false },
      }
    }
  });

  const clearDayError = (dayName) => {
    const key = DAY_NAME_TO_KEY[dayName];
    if (!key) return;
    setError((prev) => {
      if (!prev || !prev[key]) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const onupdate = (tobject) => {
    let tdayObj = {
      from_time: tobject.fromTime,
      to_time: tobject.toTime,
      selected: tobject.enabled,
      twenty_four: tobject.tfenabled,
    };
    clearDayError(tobject.day);
    setSchduleObj((prev) => {
      const newWeekly = { ...prev.schedule.weekly_schedule };
      if (tobject.day === "Sunday") newWeekly.sun = tdayObj;
      else if (tobject.day === "Monday") newWeekly.mon = tdayObj;
      else if (tobject.day === "Tuesday") newWeekly.tue = tdayObj;
      else if (tobject.day === "Wednesday") newWeekly.wed = tdayObj;
      else if (tobject.day === "Thursday") newWeekly.thu = tdayObj;
      else if (tobject.day === "Friday") newWeekly.fri = tdayObj;
      else if (tobject.day === "Saturday") newWeekly.sat = tdayObj;

      return {
        ...prev,
        schedule: {
          ...prev.schedule,
          weekly_schedule: newWeekly
        }
      };
    });
  };

  const applyBulk = (type) => {
    const isDeactivating = activeBulk === type;
    setActiveBulk(isDeactivating ? null : type);
    if (isDeactivating) return; // Just uncheck visually, keep current day selections
    // Clear all day overlap errors and the "no day selected" error
    setError((prev) => {
      if (!prev) return prev;
      const next = { ...prev };
      ["sun", "mon", "tue", "wed", "thu", "fri", "sat"].forEach((k) => delete next[k]);
      delete next.day;
      return next;
    });
    setSchduleObj((prev) => {
      const newWeekly = { ...prev.schedule.weekly_schedule };
      const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

      days.forEach((day, index) => {
        let shouldSelect = false;
        if (type === "all") shouldSelect = true;
        else if (type === "weekdays") shouldSelect = index >= 1 && index <= 5;
        else if (type === "weekends") shouldSelect = index === 0 || index === 6;
        else if (type === "alternative") shouldSelect = index % 2 === 1; // Mon, Wed, Fri

        newWeekly[day] = { ...newWeekly[day], selected: shouldSelect };
      });

      return {
        ...prev,
        schedule: {
          ...prev.schedule,
          weekly_schedule: newWeekly
        }
      };
    });
  };
  function overrideChange(e){
    const value = e.target.value;
    setName(value.trim())
    if (!value.trim()) {
      setError({ name: { message: "Please enter Name" } });

    } else {
      setError({ name: {} }); // Clear the error
    }
  }

  useEffect(() => {
    if (props.onValidationChange) {
      const hasError = !!(errorflg || (error && error.name && error.name.message));
      props.onValidationChange(hasError);
    }
  }, [errorflg, error, name, props.onValidationChange]);

  useImperativeHandle(ref, () => ({
    onsubmit: () => {
      onsubmit();
    }
  }));


  const onweeklyError = (errorInfo) => {
    const { flag, day } = errorInfo;
    const key = DAY_NAME_TO_KEY[day];
    setDayInternalErrors((prev) => {
      const next = { ...prev, [key]: flag };
      setErrorflg(Object.values(next).some(Boolean));
      return next;
    });
  };
  const onsubmit = () => {
    if (!name || name.trim() === "") {
      setError({ name: { message: "Please enter Name" } });
      if (tfocus.current) tfocus.current.focus();
      return;
    }
    if (/[^a-zA-Z0-9 ]/.test(name)) {
      setError({ name: { message: "Special characters are not allowed!" } });
      if (tfocus.current) tfocus.current.focus();
      return;
    }

    const RESERVED_NAMES = ["open", "closed", "holiday", "24/7"];
    if (RESERVED_NAMES.includes(name.trim().toLowerCase())) {
      setError({ name: { message: `"${name.trim()}" is a reserved system name. Override names cannot be Open, Closed, Holiday, or 24/7.` } });
      if (tfocus.current) tfocus.current.focus();
      return;
    }

    // Unique name check — override name must not already exist in the current batch
    const availableSchedule = props?.availablescd || currentOver || [];
    const existingNames = new Set(availableSchedule.map((o) => (o.name || "").trim().toLowerCase()));
    if (existingNames.has(name.trim().toLowerCase())) {
      setError({ name: { message: "An override with this name already exists. Please use a unique name." } });
      if (tfocus.current) tfocus.current.focus();
      return;
    }

    const weekly = schduleObj.schedule.weekly_schedule;
    const dayKeys = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

    // Validate overlap for each selected day — collect per-day errors
    const dayOverlapErrors = {};
    for (const dayKey of dayKeys) {
      const dayData = weekly[dayKey];
      if (!dayData.selected) continue;
      for (const existing of availableSchedule) {
        if (normDay(existing.day) !== dayKey) continue;
        const existFrom = convertToMinutes(existing.from || existing.from_time);
        const existTo = convertToMinutes(existing.to || existing.to_time);
        const newFrom = convertToMinutes(dayData.from_time);
        const newTo = convertToMinutes(dayData.to_time);
        if (newFrom < existTo && newTo > existFrom) {
          const existFromStr = existing.from || existing.from_time;
          const existToStr = existing.to || existing.to_time;
          dayOverlapErrors[dayKey] = `Overlaps with existing schedule: ${existFromStr} to ${existToStr}`;
          break;
        }
      }
    }

    if (Object.keys(dayOverlapErrors).length > 0) {
      setError({ ...dayOverlapErrors });
      return;
    }

    // Collect one entry per selected day
    const entries = dayKeys
      .filter((dayKey) => weekly[dayKey].selected)
      .map((dayKey) => ({
        name: name,
        day: dayKey,
        fromTime: weekly[dayKey].from_time,
        toTime: weekly[dayKey].to_time,
        tfenabled: weekly[dayKey].twenty_four,
      }));

    if (entries.length === 0) {
      setError({ day: "Please select at least one day." });
      return;
    }

    setError({});
    props.onSuccess(entries);
  };
  useEffect(()=>{
    if(props.overRideData != null){
      setcurrentOver(props.overRideData)
    }
  },[props.overRideData])
  useEffect(() => {
    const timer = setTimeout(() => {
      if (tfocus.current) {
        tfocus.current.focus();
      }
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      <div>
        <div className="tel-numbers">
          <strong>{t("name")}</strong>
        </div>
        <div className="form pt-1">
          <input
            ref={tfocus}
            type="text"
            className="form-control"
            onChange={(e) => 
              overrideChange(e)
             }
            tabIndex={-1}
            maxLength={15}
          />
          {error && error.name && (
            <p className="text-danger">{error.name.message}</p>
          )}
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap justify-content-between mb-2 mt-4">
        <MDBCheckbox label="Apply For All Days" id="bulk_all" checked={activeBulk === "all"} onChange={() => applyBulk("all")} />
        <MDBCheckbox label="Apply For Only Weekdays" id="bulk_weekdays" checked={activeBulk === "weekdays"} onChange={() => applyBulk("weekdays")} />
        <MDBCheckbox label="Apply For Only Weekends" id="bulk_weekends" checked={activeBulk === "weekends"} onChange={() => applyBulk("weekends")} />
        <MDBCheckbox label="Apply For Alternative Days" id="bulk_alternative" checked={activeBulk === "alternative"} onChange={() => applyBulk("alternative")} />
      </div>
      {schduleObj.schedule.weekly_schedule && (
        <div className="mt-4">
          {[
            { key: "sun", label: "Sunday" },
            { key: "mon", label: "Monday" },
            { key: "tue", label: "Tuesday" },
            { key: "wed", label: "Wednesday" },
            { key: "thu", label: "Thursday" },
            { key: "fri", label: "Friday" },
            { key: "sat", label: "Saturday" },
          ].map(({ key, label }) => (
            <div className="mb-3" key={key}>
              <ScheduleWeekDay
                value={schduleObj.schedule.weekly_schedule[key]}
                day={label}
                tfrom={schduleObj.schedule.weekly_schedule[key].from_time}
                tto={schduleObj.schedule.weekly_schedule[key].to_time}
                tfenabled={schduleObj.schedule.weekly_schedule[key].twenty_four}
                enabled={schduleObj.schedule.weekly_schedule[key].selected}
                updateback={onupdate}
                errorFlag={(errorInfo) => onweeklyError(errorInfo)}
              />
              {error && error[key] && !dayInternalErrors[key] && (
                <div className="text-center">
                  <span className="ms-5 text-danger" style={{ marginLeft: "10px" }}>{error[key]}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {error && error.day && (
        <p className="text-danger mt-2">{error.day}</p>
      )}
    </>
  );
});

export default AddOverride;
